/* tslint:disable */

declare var Object: any;
export interface UIUserAccountInterface {
  "id"?: number;
}

export class UIUserAccount implements UIUserAccountInterface {
  "id": number;
  constructor(data?: UIUserAccountInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UIUserAccount`.
   */
  public static getModelName() {
    return "UIUserAccount";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UIUserAccount for dynamic purposes.
  **/
  public static factory(data: UIUserAccountInterface): UIUserAccount{
    return new UIUserAccount(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'UIUserAccount',
      plural: 'UIUserAccounts',
      path: 'UIUserAccounts',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
